import PropTypes from 'prop-types';
import { PANE_ORDER } from '../../constants/checkoutConstants';

const NumberedPaneTitle = ({ pane, title }) =>
    PANE_ORDER[pane] ? (
        <span>
            {`${PANE_ORDER[pane]}. `}
            {title}
        </span>
    ) : (
        <span>{title}</span>
    );

NumberedPaneTitle.propTypes = {
    pane: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default NumberedPaneTitle;
